import { adminHttpClient } from '../../../../commons/adminHttpClient'

export type SaveIchraProductClassRequest = {
  planPeriodId: string
  classTypeIds: string[]
  productClassId?: string
  stateId?: string
}

const saveIchraProductClass = (values: SaveIchraProductClassRequest): Promise<string> => {
  return adminHttpClient.post('AdminDashboard/ichra/ProductClass', values)
}

export default saveIchraProductClass
